import * as React from "react";
import { getProviders } from '../../services/providerApiService'
import { MenuItem, H6 } from "@blueprintjs/core";
import { Suggest } from "@blueprintjs/select";
import {
  areProviderEqual,
  ProviderSelectProps,
  IProvider
} from "./providers";
import { providerTitleStyle } from '../../styles';
import './styles.css';


const ProviderSuggest = Suggest.ofType<IProvider>();

export interface ISuggestState {
  allowCreate: boolean;
  closeOnSelect: boolean;
  createdItems: IProvider[];
  fill: boolean;
  provider?: IProvider;
  items: IProvider[];
  minimal: boolean;
  openOnKeyDown: boolean;
  resetOnClose: boolean;
  resetOnQuery: boolean;
  resetOnSelect: boolean;
  onChange: Function,
}

export const defaultProvider: IProvider = {
  providerid: 0,
  phoneNumber: '',
  providerName: '',
  eligibleToServiceTrip: false,
}

export default class SuggestProviderComponent extends React.Component<ISuggestState> {

  public state: ISuggestState = {
    allowCreate: false,
    closeOnSelect: true,
    createdItems: [],
    fill: true,
    provider: undefined,
    items: [],
    minimal: false,
    openOnKeyDown: false,
    resetOnClose: true,
    resetOnQuery: true,
    resetOnSelect: false,
    onChange: Function
  };

  readonly getProviders = async () => {
    try {
      const top = 1000;
      const providers = await getProviders({ top: top });

      this.setState({
        items: providers,
      })
    }
    catch (error) {
      console.log(error);
    }
  }

  componentDidMount() {
    this.getProviders();
  }

  public render() {
    const { allowCreate, provider, minimal, ...flags } = this.state;
    return (
      <div style={{ display: 'flex', flexDirection: 'row', width: '500px', paddingTop: '3px' }}>
        <div className="modifier">
          <div style={providerTitleStyle}>
            <H6>Providers:</H6>
          </div>
        </div>
        <ProviderSuggest
          {...ProviderSelectProps}
          {...flags}
          className="bp3-input-group"
          inputValueRenderer={this.renderInputValue}
          itemsEqual={areProviderEqual}
          items={this.state.items}
          noResults={<MenuItem disabled={true} text="No results." />}
          onItemSelect={this.handleValueChange}
          popoverProps={{ minimal }}
        />
      </div>
    );
  }

  readonly renderInputValue = (provider: IProvider) => provider.providerName;

  readonly handleValueChange = (provider: IProvider) => {
    this.setState({
      provider: provider
    });

    this.props.onChange(provider);
  };
}
